import { c as _c } from "react/compiler-runtime";
import { CurrencyBalanceItemSkeleton } from "../../../flow/SideSheetFlows/ViewWalletFlow/tabs/CryptoTab/CurrencyBalanceItem";
export function CurrencySkeletons(t0) {
  const $ = _c(4);
  const {
    count: t1
  } = t0;
  const count = t1 === undefined ? 10 : t1;
  let t2;
  if ($[0] !== count) {
    t2 = new Array(count).fill(null).map(_temp);
    $[0] = count;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t2) {
    t3 = <>{t2}</>;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}
function _temp(_, i) {
  return <CurrencyBalanceItemSkeleton key={i} />;
}